export default "__VITE_ASSET__QU1_gvFI__"